/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteOneKalendereintrag$Params {

/**
 * ID des Kalendereintrags der gelöscht werden soll
 */
  kalendereintragId: string;
}

export function deleteOneKalendereintrag(http: HttpClient, rootUrl: string, params: DeleteOneKalendereintrag$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteOneKalendereintrag.PATH, 'delete');
  if (params) {
    rb.path('kalendereintragId', params.kalendereintragId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteOneKalendereintrag.PATH = '/v1/kalendereintraege/{kalendereintragId}';
